import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "vvvoraa-lang";

function get(obj, path) {
  return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "en");

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem(STORAGE_KEY, code);
  }, []);

  const t = useCallback((path) => {
    const val = get(translations[lang], path);
    if (val !== undefined) return val;
    return get(translations.en, path) ?? path;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang: changeLang, t, languages: LANGUAGES }), [lang, changeLang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
